import React, { useEffect, useRef, useState } from 'react'
import UiInputMoney from "../components/Form/UiInputMoney";
import UiInputSuggest from "../components/Form/UiInputSuggest";
import UiInputList from "../components/Form/UiInputList";
import UiInputDate from "../components/Form/UiInputDate";
import Form from "../components/Form/Form";
import { useForm, FormProvider } from "react-hook-form";
import WindowBody from '../components/Window/WindowBody';
import WindowFooter from '../components/Window/WindowFooter';
import { UiButton } from '../components/UiButton';
import { useNotification } from '../components/Core/NotificationProvider';
import { post } from '../services/ApiService';

// Lista fechada, definida em código: a situação deixou de ser cadastro quando a
// máquina de estados configurável saiu do domínio.
const situacaoList = [
    { id: 'aguarda', title: 'Aguarda' },
    { id: 'liberada', title: 'Liberada' },
    { id: 'andamento', title: 'Em andamento' },
    { id: 'concluida', title: 'Concluída' },
    { id: 'reprovada', title: 'Reprovada' },
    { id: 'cancelada', title: 'Cancelada' },
];

export default function TarefaForm(props: any) {
    const methods = useForm({
        // `liberada` e não `aguarda`: quem nasce aqui é a tarefa avulsa (pós-venda,
        // correção), que não espera dependência. As do roteiro padrão o servidor cria.
        defaultValues: props.data || { situacao: 'liberada' }
    });
    const { handleSubmit, reset, watch, setValue, getValues } = methods;
    const notification = useNotification();
    const [doContrato, setDoContrato] = useState(!!props.data?.contrato?.id);

    const contratoId = watch('contrato.id');

    // Guarda o contrato já aplicado, para o efeito não refazer a busca na carga do
    // registro.
    const contratoRef = useRef<string>(String(props.data?.contrato?.id || ''));

    useEffect(() => {
        if (props.data) {
            reset(props.data);
            contratoRef.current = String(props.data.contrato?.id || '');
            setDoContrato(!!props.data.contrato?.id);
        }
    }, [props.data, reset]);

    // Com contrato, o cliente vem dele e não se informa à mão: o servidor refaz essa
    // derivação ao gravar e ignora o que a tela mandar. O watch é só o gatilho; o
    // valor sai do getValues para não ler estado velho no commit do reset da carga.
    useEffect(() => {
        const id = String(getValues('contrato.id') || '').trim();
        if (id === contratoRef.current) return;
        contratoRef.current = id;

        if (!id) {
            setDoContrato(false);
            return;
        }

        post(`/?route=tartarefa/form&action=dadosDoContrato&contratoId=${encodeURIComponent(id)}`, {
            dados: { contratoId: id }
        })
            .then((response: any) => {
                if (!response.data?.success) {
                    notification.error(response.data?.message || 'Não foi possível ler os dados do contrato');
                    return;
                }
                if (response.data.cliente) {
                    setValue('cliente', response.data.cliente);
                }
                setDoContrato(true);
            })
            .catch(() => notification.error('Erro de comunicação ao ler o contrato'));
    }, [contratoId]);

    const salvar = (dados: any) => {
        if (!dados.tipo?.id) {
            notification.error('Tipo de tarefa é obrigatório');
            return;
        }
        if (!dados.situacao) {
            notification.error('Situação é obrigatória');
            return;
        }
        props.triggerSubmit(dados);
    };

    return (
        <FormProvider {...methods}>
            <Form onSubmit={handleSubmit(salvar)} methods={methods}>
                <WindowBody>
                    <div className="row">
                        <UiInputSuggest size={6} name="tipo" router="tartipo" idField="id" titleField="nome" label="Tipo"/>
                        <UiInputList size={6} name="situacao" list={situacaoList} idField="id" titleField="title" label="Situação" placeholder={false}/>
                        <UiInputSuggest size={6} name="contrato" router="contrato" idField="id" titleField="cli_nome" label="Contrato"/>
                        <UiInputSuggest size={6} name="cliente" router="cliente" idField="id" titleField="nome" label="Cliente" disabled={doContrato}/>
                        <UiInputSuggest size={6} name="responsavel" router="unpessoa" idField="id" titleField="nome" label="Responsável"/>
                        <UiInputSuggest size={6} name="instalador" router="uninstalador" idField="id" titleField="nome" label="Instalador"/>
                        <UiInputDate size={6} name="agendadaEm" label="Agendada em"/>
                        <UiInputMoney size={6} name="valorMontador" label="Valor do montador"/>
                    </div>
                </WindowBody>

                <WindowFooter>
                    <UiButton variant="secondary" onClick={props.triggerClose}>Fechar</UiButton>
                    <UiButton variant="primary" type="submit">Salvar</UiButton>
                </WindowFooter>
            </Form>
        </FormProvider>
    )
}
